import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";
import { couponSchema } from "../coupon";
import { rateSchema } from "../rate";

export const paymetSchema = z.object({
  id: z.string(),
  reference: z.string(),
  rateId: z.string(),
  couponId: z.string().nullable().optional(),
  userId: z.string(),
  Amount: z.number(),
  toAmbassador: z.number().nullable().optional(),
  status: z.number(),
  openDate: z.coerce.date(),
  closeDate: z.coerce.date().nullable(),
  idempotencyKey: z.string().optional().nullable(),
});

export class PaymentDto extends createZodDto(paymetSchema) {}

export const paymentWithUserAndCouponSchema = paymetSchema.merge(
  z.object({
    user: userSchema,
    rate: rateSchema,
    coupon: couponSchema.nullable().default(null),
  }),
);
export class PaymentWithUserAndCoupon extends createZodDto(paymentWithUserAndCouponSchema) {}
